import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getSubscriptionReport } from "../../../services/ReportService";

const ActivePackagesModal = ({ show, onHide }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      fetchPreviewData();
    }
  }, [show]);

  const fetchPreviewData = async () => {
    setLoading(true);
    try {
      const res = await getSubscriptionReport(0, 10, "");
      const items = Array.isArray(res) ? res : res?.content || res?.data || [];
      setData(items);
    } catch (error) {
      console.error("Error fetching preview active packages data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowMore = () => {
    onHide();
    navigate("/admin/package-reports");
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-18 fw-bold">
          <i className="fas fa-boxes text-warning me-2"></i>
          Active Packages - Packages List
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="warning" />
            <p className="mt-2 text-muted">Loading packages...</p>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover responsive className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Package Name</th>
                  <th>Package Type</th>
                  <th>Duration (Days)</th>
                  <th>Price</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data.map((item, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td className="fw-semibold">
                        {item?.packageType?.name || item?.name || "-"}
                      </td>
                      <td>
                        {item?.packageType?.packageTime ||
                          item?.packageCategory ||
                          item?.category ||
                          "-"}
                      </td>
                      <td>
                        {item?.packageType?.days ||
                          item?.days ||
                          item?.duration ||
                          "-"}
                      </td>
                      <td className="fw-bold text-success">
                        ₹ {item?.ammount ?? item?.amount ?? item?.price ?? 0}
                      </td>
                      <td>
                        <span
                          className={`badge badge-sm ${item?.status === "Active" ||
                              item?.status === "ACTIVE" ||
                              item?.status === "Enabled" ||
                              item?.enabled
                              ? "badge-success"
                              : "badge-secondary"
                            }`}
                        >
                          {item?.status || (item?.enabled ? "Active" : "Active")}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center py-4 text-muted">
                      No packages found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleShowMore}>
          <i className="fas fa-external-link-alt me-2"></i> Show More (View Full Report)
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ActivePackagesModal;
